function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var WebformContainer = function WebformContainer(props) {
  var entity = props.entity,
    WebformMapper = props.WebformMapper;
  var classNames = entity.getIn(['#attributes', 'class', 0], '');

  // Remove al non-element children.
  var children = entity;
  children.keySeq().forEach(function (k) {
    if (k.indexOf('#') === 0) {
      children = children.delete(k);
    }
  });

  // Recursively render children.
  return /*#__PURE__*/React.createElement("div", {
    className: "webform-container ".concat(classNames)
  }, /*#__PURE__*/React.createElement(WebformMapper, _extends({}, props, {
    entities: children
  })));
};
export default WebformContainer;